const PAYMENT_TERMS = {
    SINGLE: 1,
    QUARTERLY: 4,
    MONTHLY_ONE_UP_FRONT: 12,
    MONTHLY_TWO_UP_FRONT: 12,
    // TODO: Deprecate the following once the API and all IONs have been updated
    SINGLE_PAYMENT: 1,
    QUARTERLY_PAYMENTS: 4,
    MONTHLY_PAYMENTS: 12,
};
const POLICY_ID_GENERATOR_TYPES = {
    UUID: 'UUID',
    INCREMENTAL: 'INCREMENTAL',
};
const ION_EMAIL_TRIGGERS = {
    NEW_POLICY: 'NEW_POLICY',
    RENEWAL_SUCCESS: 'RENEWAL_SUCCESS',
    PRENEWAL: 'PRENEWAL',
    ENDORSEMENT: 'ENDORSEMENT',
    CANCELLATION: 'CANCELLATION',
    REFUND: 'REFUND',
};
const ION_FORM_TRIGGERS = {
    NEW_POLICY: 'NEW_POLICY',
    ENDORSEMENT: 'ENDORSEMENT',
    CANCELLATION: 'CANCELLATION',
};
const ION_TYPE = {
    BLUEPRINT: 'BLUEPRINT',
    OFFERING: 'OFFERING',
    BUNDLE: 'BUNDLE',
};
const ISSUANCE_TYPE = {
    INDIVIDUAL: 'INDIVIDUAL',
    GROUP: 'GROUP',
    COMMERCIAL: 'COMMERCIAL',
    BENEFIT_INDIVIDUAL: 'BENEFIT_INDIVIDUAL',
    BENEFIT_GROUP: 'BENEFIT_GROUP',
    BENEFIT_COMMERCIAL: 'BENEFIT_COMMERCIAL',
};
const ISSUANCE_BASIS = {
    VOLUNTARY: 'VOLUNTARY',
    INVOLUNTARY: 'INVOLUNTARY',
};
const ISSUANCE_LINE = {
    AD_AND_D: 'AD_AND_D',
    ACCIDENT: 'ACCIDENT',
    TICKET_CANCELLATION: 'TICKET_CANCELLATION',
    REGISTRATION_CANCELLATION: 'REGISTRATION_CANCELLATION',
    PROPERTY_AND_CASUALTY: 'PROPERTY_AND_CASUALTY',
    TRAVEL: 'TRAVEL',
    HEALTH: 'HEALTH',
    PET: 'PET',
    AUTO: 'AUTO',
    HOME: 'HOME',
    RENTERS: 'RENTERS',
    WHOLE_LIFE: 'WHOLE_LIFE',
    TERM_LIFE: 'TERM_LIFE',
    WORKERS_COMPENSATION: 'WORKERS_COMPENSATION',
    DISABILITY: 'DISABILITY',
    LONG_TERM_CARE: 'LONG_TERM_CARE',
    SHORT_TERM_CARE: 'SHORT_TERM_CARE',
    CRITICAL_ILLNESS: 'CRITICAL_ILLNESS',
    CANCER: 'CANCER',
    UMBRELLA: 'UMBRELLA',
    CYBER_LIABILITY: 'CYBER_LIABILITY',
    FLOOD: 'FLOOD',
    IDENTITY: 'IDENTITY',
    CRYPTO: 'CRYPTO',
    PARENTAL_LEAVE: 'PARENTAL_LEAVE',
    KEY_PERSON: 'KEY_PERSON',
    SHIPPING: 'SHIPPING',
    MOVING: 'MOVING',
    WEDDING: 'WEDDING',
    COLD_FEET: 'COLD_FEET',
    DIVORCE: 'DIVORCE',
    MULTI_BIRTH: 'MULTI_BIRTH',
    BODY_PART: 'BODY_PART',
    LOTTERY: 'LOTTERY',
    CONTEST: 'CONTEST',
    KIDNAPPING: 'KIDNAPPING',
    MISCELLANEOUS: 'MISCELLANEOUS',
};
const ION_STATUS = {
    DRAFT: 'DRAFT',
    SUBMITTED: 'SUBMITTED',
    PUBLISHED: 'PUBLISHED',
    ARCHIVED: 'ARCHIVED',
};
const FIELDS_OPTIONS = {
    STRING: 'STRING',
    NUMBER: 'NUMBER',
    DATE: 'DATE',
    FIELDS: 'FIELDS',
    BOOL: 'BOOL',
    ARRAY: 'ARRAY',
    DICTIONARY: 'DICTIONARY',
};
const TOP_LEVEL_FIELD_IDS = ['customer', 'policy', 'payment'];
const FORMAT_OPTIONS = {
    MASK: 'MASK',
    CURRENCY: 'CURRENCY',
    NUMBER: 'NUMBER',
};
const VIEW_OPTIONS = {
    GROUP: 'GROUP',
    CHECKOUT: 'CHECKOUT',
    OFFER: 'OFFER',
    OFFER_ONLY: 'OFFER_ONLY',
    POST_CHECKOUT: 'POST_CHECKOUT',
    QUOTE: 'QUOTE',
};
const ACTION_TYPES = {
    CALL: 'CALL',
    POST_MESSAGE: 'POST_MESSAGE',
};
const ACTION_SUB_TYPES = {
    TRIGGER: 'TRIGGER',
    RESOLVE: 'RESOLVE',
    LOAD: 'LOAD',
};
const UI_DISPLAY_ELEMENT_OPTIONS = {
    INPUT: 'INPUT',
    MASKED_INPUT: 'MASKED_INPUT',
    SELECT: 'SELECT',
    SLIDER: 'SLIDER',
    TEXTAREA: 'TEXTAREA',
    RADIO: 'RADIO',
    DATE_PICKER: 'DATE_PICKER',
    CHECKBOX: 'CHECKBOX',
    CREATABLE_SELECT: 'CREATABLE_SELECT',
    REFERENCE: 'REFERENCE',
    ADDRESS_AUTOCOMPLETE: 'ADDRESS_AUTOCOMPLETE',
};
const CONTENT_TYPE = {
    OFFER: 'OFFER',
    COMPLIANCE: 'COMPLIANCE',
};
const CONTENT_POSITIONS = {
    BEFORE_FIELDS: 'BEFORE_FIELDS',
    AFTER_FIELDS: 'AFTER_FIELDS',
    BELOW_NAV: 'BELOW_NAV',
};
const ION_FIELD_TYPES = {
    STRING: 'STRING',
    FIELDS: 'FIELDS',
    DATE: 'DATE',
    BOOL: 'BOOL',
    NUMBER: 'NUMBER',
    ARRAY: 'ARRAY',
    DICTIONARY: 'DICTIONARY',
};
const FAKER_TYPES = {
    STRING: 'noun',
    BOOL: 'bool',
    NUMBER: 'number',
    DATE: 'date',
    ARRAY: 'array',
    DICTIONARY: 'dictionary',
};
// these are custom fakerTypes that can have values build inside buddyFaker
const FAKER_TYPES_EXTENSIONS = {
    COMPANY_NAME: 'companyName',
    JOB_TITLE: 'jobTitle',
};
const ION_FIELD_IDS = {
    EMAIL: 'email',
    PHONE: 'phone',
    POSTAL_CODE: 'postalCode',
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    LINE1: 'line1',
    LINE2: 'line2',
    CITY: 'city',
    STATE: 'state',
};
const HTTP_METHODS = [
    'GET',
    'POST',
    'PUT',
    'PATCH',
    'DELETE',
    'OPTIONS',
];
const BODY_TYPES = [
    'json',
    'x-www-form-urlencode',
];
const VALID_TIME_FRAMES = [
    'BEFORE',
    'AFTER',
];
const VALID_TIME_FRAME_UNITS = [
    'DAY',
    'WEEK',
    'MONTH',
];
const EXPIRATION_VALID_TIME_FRAME_UNITS = [...VALID_TIME_FRAME_UNITS, 'MILLISECOND'];
const VALID_TIME_FRAME_DATES = [
    'PURCHASE',
    'START',
    'END',
];
const _FROM_LOCATIONS = [
    'CACHE',
    'SECRET',
    'SESSION',
];
const PAYMENT_TYPES = {
    ACH: 'ACH',
    CUSTOMER_REFERENCE: 'CUSTOMER_REFERENCE',
    NO_COLLECT: 'NO_COLLECT',
    PAYMENT_METHOD_ID: 'PAYMENT_METHOD_ID',
    PAYMENT_TOKEN: 'PAYMENT_TOKEN',
};
const PAYMENT_GATEWAYS = {
    STRIPE: 'STRIPE',
};
const PAYMENT_FIELDS = {
    PAYMENT_TYPE: 'paymentType',
    PAYMENT_GATEWAY: 'paymentGateway',
    PAYMENT_TOKEN: 'paymentToken',
    PAYMENT_METHOD_REFERENCE: 'paymentMethodReference',
    ACH_DATA: 'achData',
    PAYMENT_METHOD_ID: 'paymentMethodId',
};
const DEFAULT_TIMEZONE = 'UTC'; // UTC
export { _FROM_LOCATIONS, ACTION_TYPES, ACTION_SUB_TYPES, BODY_TYPES, CONTENT_POSITIONS, CONTENT_TYPE, DEFAULT_TIMEZONE, EXPIRATION_VALID_TIME_FRAME_UNITS, FAKER_TYPES, FAKER_TYPES_EXTENSIONS, FIELDS_OPTIONS, FORMAT_OPTIONS, HTTP_METHODS, ION_EMAIL_TRIGGERS, ION_FIELD_IDS, ION_FIELD_TYPES, ION_STATUS, ION_TYPE, ISSUANCE_BASIS, ISSUANCE_LINE, ISSUANCE_TYPE, PAYMENT_GATEWAYS, PAYMENT_TERMS, PAYMENT_TYPES, POLICY_ID_GENERATOR_TYPES, TOP_LEVEL_FIELD_IDS, UI_DISPLAY_ELEMENT_OPTIONS, VALID_TIME_FRAMES, VALID_TIME_FRAME_UNITS, VALID_TIME_FRAME_DATES, VIEW_OPTIONS, ION_FORM_TRIGGERS, };
